module.exports = __webpack_public_path__ + "img/美莱.fb5296d.png";